import React from 'react';
import { Input } from '../../ui/input';
import CommonFormFields from './CommonFormFields';

/**
 * General Assistance Form - Everyday task help and support
 */
const GeneralAssistanceForm = ({ formData, setFormData }) => {
  const updateField = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  return (
    <div className="space-y-4">
      <CommonFormFields formData={formData} setFormData={setFormData} />
      
      <hr className="my-4" />
      <h4 className="font-bold text-lg">Task Details</h4>
      
      <div>
        <label className="block text-sm font-medium mb-2">Task Category *</label>
        <select
          value={formData.task_category || ''}
          onChange={(e) => updateField('task_category', e.target.value)}
          className="w-full p-3 border rounded-xl"
          required
        >
          <option value="">Select category</option>
          <option value="waiting">Waiting for Service/Delivery</option>
          <option value="organizing">Organizing/Sorting</option>
          <option value="moving_help">Moving Help (Light)</option>
          <option value="setup">Setup/Assembly</option>
          <option value="other">Other</option>
        </select>
      </div>
      
      <div>
        <label className="block text-sm font-medium mb-2">Task Description *</label>
        <textarea
          value={formData.task_description || ''}
          onChange={(e) => updateField('task_description', e.target.value)}
          className="w-full p-3 border rounded-xl min-h-[100px]"
          placeholder="Describe what you need help with"
          required
        />
      </div>
      
      <div>
        <label className="block text-sm font-medium mb-2">Detailed Requirements *</label>
        <textarea
          value={formData.detailed_requirements || ''}
          onChange={(e) => updateField('detailed_requirements', e.target.value)}
          className="w-full p-3 border rounded-xl min-h-[80px]"
          placeholder="Specific instructions, expectations, etc."
          required
        />
      </div>
      
      <hr className="my-4" />
      <h4 className="font-bold text-lg">Location & Time</h4>
      
      <div>
        <label className="block text-sm font-medium mb-2">Service Address *</label>
        <Input
          value={formData.service_address || ''}
          onChange={(e) => updateField('service_address', e.target.value)}
          placeholder="Full address"
          required
        />
      </div>
      
      <div>
        <label className="block text-sm font-medium mb-2">Estimated Duration (hours)</label>
        <Input
          type="number"
          step="0.5"
          min="0.5"
          value={formData.estimated_duration || 1}
          onChange={(e) => updateField('estimated_duration', parseFloat(e.target.value))}
        />
      </div>
      
      <hr className="my-4" />
      <h4 className="font-bold text-lg">Additional Info</h4>
      
      <label className="flex items-center gap-2">
        <input
          type="checkbox"
          checked={formData.supplies_provided !== false}
          onChange={(e) => updateField('supplies_provided', e.target.checked)}
          className="w-4 h-4"
        />
        I will provide any needed supplies/tools
      </label>
      
      <label className="flex items-center gap-2">
        <input
          type="checkbox"
          checked={formData.heavy_lifting_required || false}
          onChange={(e) => updateField('heavy_lifting_required', e.target.checked)}
          className="w-4 h-4"
        />
        Heavy lifting may be required
      </label>
      
      {formData.heavy_lifting_required && (
        <Input
          value={formData.max_weight || ''}
          onChange={(e) => updateField('max_weight', e.target.value)}
          placeholder="Maximum weight (lbs)"
          className="mt-2"
        />
      )}
    </div>
  );
};

export default GeneralAssistanceForm;
